import {inject, customAttribute, DOM, bindable, bindingMode} from 'aurelia-framework';
import _ from 'lodash';
import {ScrollingArea} from "./scrolling-area";

@customAttribute('scroll-update')
@inject(DOM.Element)
export class ScrollUpdate {

  /**
   * @type {WeakMap}
   * @static
   */
  static updateMap: WeakMap<ScrollingArea, Function> = new WeakMap();

  /**
   * @type {ScrollingArea}
   */
  @bindable({
    primaryProperty: true,
    defaultBindingMode: bindingMode.oneTime
  }) scroll: ScrollingArea = null;

  __isLast: boolean;

  constructor(private __targetEl) {
  }

  attached() {
    if (!this.scroll) {
      this.scroll = this.__tryFindScroll();
    }

    if (!ScrollUpdate.updateMap.has(this.scroll)) {
      ScrollUpdate.updateMap.set(this.scroll, _.debounce(() => {
        this.scroll.update();
      }, 16));
    }

    if (this.__isLast && this.scroll) {
      this.scroll.update();
    }
  }

  detached() {
    ScrollUpdate.updateMap.get(this.scroll)();
  }

  bind(bindingContext, overridingContext) {
    if (overridingContext.$last === true) {
      this.__isLast = true;
    }
  }

  __tryFindScroll() {
    let parent = this.__targetEl;
    while ((parent = parent.parentElement) !== null) {
      if (parent.tagName === 'SCROLLING-AREA') {
        return parent.au.controller.viewModel;
      }
    }

    throw 'scroll not found';
  }

}
